import React from 'react';
import { connect } from 'react-redux';

import { setQuestionnaireTitle } from '../../../../../../_actions/questionnaire.actions'

const QuestionnaireName = ({ title, setTitle }) => {
  return <div className="form-group">
    <label><span className="text-danger">*</span> <strong>Form Name</strong></label>
    <input
      onChange={(e) => { setTitle(e.target.value) }}
      defaultValue={title}
      type="text"
      className="form-control"
    />
  </div>
}

const mapStateToProps = (state) => { return { title: state.questionnaire.current.title } }

const mapDispatchToProps = (dispatch) => {
  return { setTitle: (title) => { dispatch(setQuestionnaireTitle(title)) } }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireName);